export const LAST_VISITED_PINCODE = "lastVisitedPincode";
export const LAST_VISITED_ADDRESS = "lastVisitedAddress";
export const LAST_VISITED_COUNTRIES = "lastVisitedCountries";
export const SELECTED_INTERNATIONAL_CITY = "selectedIntlCity";
export const LAST_VISITED_INTERNATIONAL_LOCATION = "lastVisitedIntlLocation";
export const LAST_VISITED_INTERNATIONAL_CITY = "lastVisitedIntlCity";
export const PF_COOKIE = "pf";
export const INTERNATIONAL_PF_COOKIE = "intlPf";
export const SELECTED_SAVED_ADDRESS = "selectedSavedAddress";
export const LAST_VISITED_PLACE_ID = "lastVisitedPlaceId";
export const LAST_VISITED_LAT_LONG = "lastVisitedLatLong";
// "lat,long" of the latest selected / added saved address (gate picks use LAST_VISITED_LAT_LONG and clear this).
export const LAST_VISITED_ADDRESS_LAT_LONG = "lastVisitedAddressLatLong";
export const LAST_VISITED_ACCURACY_TYPE = "accuracyType";
// Comma separated Google types of the last selected place; drives the accuracy weightage level.
export const LAST_VISITED_PLACE_TYPES = "lastVisitedPlaceTypes";
export const LAST_VISITED_ACCURACY_LEVEL = "lastVisitedAccuracyLevel";
export const SELECTED_SAVED_ADDRESS_USERNAME = "selectedSavedAddressUserName";
export const PARTNER = "partner";
export const HDFC_SMARTBUY = "HDFC_SMARTBUY";
export const JSESSIONID = "JSESSIONID";
export const CART_EXPIRY_KEY = "cartExpiryTimestamp";
